import React, {useEffect, useState} from 'react';
import HeaderWithBack from '../../components/HeaderWithBack';
import { useNavigate } from 'react-router';
import {toast} from "react-toastify";
import {CategoryDTO} from "../../dtos/category.dto";
import {useRecoilValue} from "recoil";
import {fetchAPIResponseSelector} from "../../store/user.atom";
import {IngredientDTO} from "../../dtos/ingredient.dto";
import {useParams} from "react-router-dom";

type Props = {};

const EditIngredient: React.FC<Props> = () => {

  const { id } = useParams<{ id: string }>();
  const navigate = useNavigate();

  const fetchAPIResponse = useRecoilValue(fetchAPIResponseSelector);
  const [ingredientName, setIngredientName] = useState<string>('');
  const [ingredientPrice, setIngredientPrice] = useState<string>('');

  useEffect(() => {
    const fetchIngredient = async () => {
      try {
        const categoryData = await fetchAPIResponse<IngredientDTO>(`/ingredients/${id}`, {
          method: "GET",
          headers: {
            "Accept": "application/json"
          }
        });

        setIngredientName(categoryData.data.name);
        setIngredientPrice(categoryData.data.base_price.toFixed(2));
      } catch (error) {
        toast.error((error as Error).message)
      }
    };

    fetchIngredient();
  }, [id]);

  const handleEditIngredient = async () => {
    if(ingredientName === '' || ingredientPrice === '') {
      toast.error("Fill in contents before creating the ingredient")
      return;
    }

    try {
      await fetchAPIResponse<IngredientDTO>(`/ingredients/${id}`, {
        method: "PUT",
        headers: {
          "Accept": "application/json",
          "Content-Type": "application/json"
        },
        body: JSON.stringify({
          name: ingredientName,
          base_price: Number(ingredientPrice)
        })
      });

      navigate('/ingredients')
    } catch (e) {
      toast.error((e as Error).message)
    }
  };

  return (
    <div className='flex flex-col w-full h-full overflow-auto items-center py-10 gap-6'>
      <HeaderWithBack previousPage={'Ingredients'} currentPage={'Edit Ingredient'} previousPageUrl={'/ingredients'} />
      <div className='zbh-card w-11/12 max-w-2xl p-8'>
        <h2 className="font-display text-base font-semibold text-ink mb-5">Edit ingredient</h2>
        <div className="space-y-4">
          <div>
            <label className="zbh-label">Name</label>
            <input type='text' placeholder='e.g. Cheddar cheese' value={ingredientName}
              onChange={(e) => setIngredientName(e.target.value)} className='zbh-input' />
          </div>
          <div>
            <label className="zbh-label">Price ($)</label>
            <input type='text' placeholder='0.00' value={ingredientPrice}
              onChange={(e) => setIngredientPrice(e.target.value)} className='zbh-input' />
          </div>
        </div>
        <button onClick={handleEditIngredient} className='zbh-btn-accent w-full mt-6'>
          Save changes
        </button>
      </div>
    </div>
  );
};

export default EditIngredient;
